module.exports = __webpack_public_path__ + "img/event-fusion-straciatella-2025.26ead56.jpg";